import React from 'react';

import { BUTTON_DISPLAY_NAME } from '../Button';

import { CtaType } from './types';

export function extractDisplayName(type: React.FunctionComponent): string {
    return type.displayName || type.name || 'Unknown';
}

export function isSupportedCtaComponent(component: CtaType): boolean {
    const componentType = component.type;

    if (typeof componentType === 'function') {
        const displayName = extractDisplayName(componentType as React.FunctionComponent);

        return displayName === BUTTON_DISPLAY_NAME;
    }

    return false;
}
